export class PrimaryAction {
  public actions: Array<InterACT.Interfaces.IActions>;
  public visible: Boolean;
  public multiple: Boolean;
  public isOpen: Boolean;

  public show() {
    this.visible = true;
  }

  public arrowDirection() {
    return this.isOpen ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
  }

  public hide() {
    this.visible = false;
  }

  public setActions(actions: Array<any>) {
    actions.forEach( (action) => !action.icon ? action.icon = 'add' : action.icon);
    this.multiple = !(actions.length === 1);
    this.actions = this.multiple ? actions : actions[0];
    this.show();
  }

  public clearActions() {
    this.isOpen = false;
    this.hide();
  }
}